import axios, { AxiosRequestConfig, AxiosResponse, AxiosError } from 'axios';
import { ApiRoutes } from '../routes/routeConstants/apiRoutes';
import Notification from 'shared/components/Notification';
import { NotificationTypes } from 'enums/notificationTypes';
import { defaultErrorMessage } from 'constants/constants';
import {
  BLOB_TYPE,
  FILE_RESPONSE,
  JSON_RESPONSE,
} from 'views/CompanyDashboard/constants';
import { PROCESSING_FACILITY_NOT_FOUND } from 'constants/errorCode.constants';

// Add error codes for which notification messages must be skipped
const skippableErrorCodes = [PROCESSING_FACILITY_NOT_FOUND];

// Define the type for headers
export const getHeaders = (): Record<string, string> => {
  const user = localStorage.getItem('user') || '';
  return {
    'Content-Type': 'application/json',
    Authorization: user,
  };
};

const axiosInstance = axios.create({
  baseURL: ApiRoutes.BASE_URL,
  timeout: 40000, // Increase the timeout for image upload
});

// Request interceptor
axiosInstance.interceptors.request.use(function (config: AxiosRequestConfig) {
  config.headers = getHeaders();
  return config;
});

// Response interceptor
axiosInstance.interceptors.response.use(
  (response): any => {
    return {
      data: response.data,
      message: response.statusText,
      status: response.status,
      headers: response.headers,
    };
  },
  error => {
    const { response, request } = error;

    switch (response.status) {
      case 401:
        localStorage.clear();
        return (window.location.href = '/');

      case 403:
      case 404:
      case 400:
        //Keeping it common
        const isSkippableError = skippableErrorCodes.includes(
          response?.data?.error_code
        );
        const responseHeaderContent = response.headers['content-type'];
        const uploadError =
          request.responseType === BLOB_TYPE &&
          (responseHeaderContent.includes(JSON_RESPONSE) ||
            responseHeaderContent.includes(FILE_RESPONSE));
        if (uploadError || isSkippableError) break;
        Notification({
          message: response?.data?.error?.message ?? defaultErrorMessage,
          description: '',
          type: NotificationTypes.ERROR,
        });
        break;
      case 500:
        Notification({
          message: response?.data?.message ?? defaultErrorMessage,
          description: '',
          type: NotificationTypes.ERROR,
        });
        break;
      default:
        Notification({
          message: defaultErrorMessage,
          description: '',
          type: NotificationTypes.ERROR,
        });
    }

    return Promise.reject(error);
  }
);

export default axiosInstance;